// extracted by mini-css-extract-plugin
export default {"root":"o_PhY"};